export enum AnomalyLevel {
    DEBUG, INFO, WARN, ERROR, CRITICAL
}
